"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _styledNormalize = require("styled-normalize");
var _mixins = require("../mixins");
var _reset = require("./globalStyles/reset");
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var GlobalStyles = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n\n    html {\n        box-sizing: border-box;\n        min-height: 100%;\n        -moz-osx-font-smoothing: grayscale;\n        -webkit-font-smoothing: antialiased;\n    }\n\n    body {\n        font-family: ", ";\n        font-size: ", ";\n        line-height: ", ";\n        /* background-color: ", "; */\n        color: ", ";\n        font-weight: ", ";\n    }\n\n    * {\n        &,\n        &:before,\n        &:after {\n            box-sizing: inherit;\n        }\n    }\n\n    address,\n    blockquote,\n    p,\n    pre,\n    dl,\n    ol,\n    ul,\n    figure,\n    hr,\n    table,\n    fieldset {\n        margin-bottom: ", ";\n    }\n\n    dd,\n    ol,\n    ul {\n        margin-left: ", ";\n    }\n\n    img {\n        max-width: 100%;\n        max-height: 100%;\n        vertical-align: middle;\n    }\n\n    h1 {\n        ", "\n    }\n    h2 {\n        ", "\n    }\n    h3 {\n        ", "\n    }\n    h4 {\n        ", "\n    }\n    h5 {\n        ", "\n    }\n    h6 {\n        ", "\n    }\n\n    p {\n        margin-bottom: ", ";\n    }\n\n    hr {\n        display: block;\n        width: 100%;\n        border: 0;\n        border-top: ", ";\n        padding: 0;\n        margin: ", " auto;\n    }\n\n    strong,\n    b {\n        font-weight: ", ";\n    }\n\n    button {\n        cursor: pointer;\n    }\n\n    .ReactModal__Body--open {\n        overflow: hidden;\n    }\n"])), _styledNormalize.normalize, _reset.reset, function (props) {
  return props.theme.fontFamily.base.name;
}, function (props) {
  return props.theme.fontSizes.base;
}, function (props) {
  return props.theme.lineHeights.base;
}, function (props) {
  return props.theme.colors.backgroundSecondary;
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.fontWeights.normal;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.spaces.base;
}, (0, _mixins.hTagMixin)("h1"), (0, _mixins.hTagMixin)("h2"), (0, _mixins.hTagMixin)("h3"), (0, _mixins.hTagMixin)("h4"), (0, _mixins.hTagMixin)("h5"), (0, _mixins.hTagMixin)("h6"), function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.border;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.fontWeights.bold;
});
var _default = GlobalStyles;
exports["default"] = _default;